export { default as DocumentsBottomSheet } from './DocumentsBottomSheet.vue';
